import request from '@/utils/request'

export function searchAll (option, searchInput) {
  return request({
    url: '/mbodymap/bodySite/searchAll',
    method: 'get',
    params: {
      option,
      searchInput
    }
  })
}



// WEBPACK FOOTER //
// ./src/api/allWebSite.js